import { render, staticRenderFns } from "./ShweDetail.vue?vue&type=template&id=15f60ac4&scoped=true&"
import script from "./ShweDetail.vue?vue&type=script&lang=js&"
export * from "./ShweDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f60ac4",
  null
  
)

export default component.exports